import { Component, inject, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'directory-portal-expired-preview',
  templateUrl: './expired-preview.component.html',
})
export class ExpiredPreviewComponent implements OnInit {
  private meta = inject(Meta);
  private titleService = inject(Title);

  ngOnInit(): void {
    this.titleService.setTitle('Expired Preview');
    this.meta.updateTag({
      name: 'description',
      content: 'Preview expired – click Preview again in the editor.',
    });
    this.meta.updateTag({ name: 'robots', content: 'noindex' });
  }
}
